const temp = [
  { text: "Capital", value: "Capital" },
  { text: "Escobar", value: "Escobar" },
  { text: "General San Martín", value: "General San Martín" },
  { text: "Jose C Paz", value: "Jose C Paz" },
  { text: "Malvinas Argentinas", value: "Malvinas Argentinas" },
  { text: "Pilar", value: "Pilar" },
  { text: "San Fernando", value: "San Fernando" },
  { text: "San Isidro", value: "San Isidro" },
  { text: "San Miguel", value: "San Miguel" },
  { text: "Tigre", value: "Tigre" },
  { text: "Vicente Lopez", value: "Vicente Lopez" },
  { text: "Acessuso", value: "Acessuso" },
  { text: "Beccar", value: "Beccar" },
  { text: "Bella Vista", value: "Bella Vista" },
  { text: "Benavidez", value: "Benavidez" },
  { text: "Boulogne", value: "Boulogne" },
  { text: "Campo de Mayo", value: "Campo de Mayo" },
  { text: "Carapachay", value: "Carapachay" },
  { text: "Carupa", value: "Carupa" },
  { text: "Del Viso", value: "Del Viso" },
  { text: "Delta", value: "Delta" },
  { text: "Florida", value: "Florida" },
  { text: "Garin", value: "Garin" },
  { text: "General Pacheco", value: "General Pacheco" },
  { text: "General Sarmiento", value: "General Sarmiento" },
  { text: "Grand Bourg", value: "Grand Bourg" },
  { text: "Ingeniero Maschwitz", value: "Ingeniero Maschwitz" },
  { text: "Jose Leon Suarez", value: "Jose Leon Suarez" },
  { text: "La Lucina", value: "La Lucina" },
  { text: "Los Polvorines", value: "Los Polvorines" },
  { text: "Martinez", value: "Martinez" },
  { text: "Munro", value: "Munro" },
  { text: "Pablo Noquez", value: "Pablo Noquez" },
  { text: "Talar de Pacheco", value: "Talar de Pacheco" },
  { text: "Tortuguitas", value: "Tortuguitas" },
  { text: "Villa Adelina", value: "Villa Adelina" },
  { text: "Villa Ballester", value: "Villa Ballester" },
  { text: "Otro", value: "Otro" }
];
export default temp;
